import {AggregateValidator, FormValidationAPI,} from "./AggregateValidator.ts";
import {FormSchema} from "../../DynamicFormTypes.ts";
import {ReportFormMetaData, Trigger} from "../../../../api/ApiTypes.ts";

export class BackendOnlyValidator extends AggregateValidator {
    constructor(triggers: Trigger[] = [],
                validateFunction: FormValidationAPI,
                formSchema: FormSchema,
                metaData: ReportFormMetaData) {
        super(triggers, validateFunction, formSchema, metaData);
    }
}